import { apiClient } from "./client";

export interface QuestView {
  id: string;
  code: string;
  title: string;
  description: string;
  rewardTokens: string;
  targetProgress: number;
  progress: number;
  completedAt: string | null;
  claimed: boolean;
}

export interface QuestsTodayResponse {
  periodKey: string;
  quests: QuestView[];
  streak: { current: number; longest: number };
}

export async function fetchQuestsToday(): Promise<QuestsTodayResponse> {
  const { data } = await apiClient.get<QuestsTodayResponse>("/quests/today");
  return data;
}

export async function claimQuest(templateId: string): Promise<{ claimedTokens: string }> {
  const { data } = await apiClient.post<{ claimedTokens: string }>(
    `/quests/${templateId}/claim`
  );
  return data;
}
